export default __webpack_public_path__ + "static/media/review2.303cd5ed.jpg";